import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const publishableKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;

if (!url || !publishableKey) {
  // eslint-disable-next-line no-console
  console.warn('Supabase is not configured. Copy .env.example to .env.local and fill in the values.');
}

// One shared client. The publishable key is safe in the browser because every table is protected by row security.
export const supabase = createClient(url || 'http://localhost', publishableKey || 'missing-key', {
  auth: { persistSession: true, autoRefreshToken: true },
});

// Public link for a file stored in a public bucket (media, brochures). Returns null when there is no path.
export const publicFileUrl = (bucket, path) =>
  path ? supabase.storage.from(bucket).getPublicUrl(path).data.publicUrl : null;
